import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import { Typography, Button, Snackbar } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import api from "../../../../../apiReference";
import "./QualifiedStudents.css";
import { USER_LEVELS } from "../../../../../../constants/AllConstants";
import { useSelector } from 'react-redux';
import { selectCurrentExam } from '../../../../../../features/exams/examSlice';

const QualifiedStudents = () => {
  const [qualifiedStudentsData, setQualifiedStudentsData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const currentExam = useSelector(selectCurrentExam);
  const examCode = currentExam.currentExam;
  const loginUserDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userLevel = USER_LEVELS[loginUserDetails.role];

  useEffect(() => {
    const fetchQualifiedStudentsData = async () => {
      try {
        const response = await api.get(`/api/examstudents/fetchQualifiedStudents/${examCode}`);

        const dataWithIds = response.data.map((student, index) => ({
          ...student,
          id: index + 1,
          action: student.registered ? "Deregister" : "Register"
        }));
        setQualifiedStudentsData(dataWithIds);
      } catch (error) {
        console.log(error);
      }
    };
    fetchQualifiedStudentsData();
  }, [examCode]);

  const handleAction = (row) => {
    const updatedStudents = qualifiedStudentsData.map(student =>
      student.id === row.id ? { ...student, registered: !student.registered } : student
    );
    setQualifiedStudentsData(updatedStudents);
    setSnackbarOpen(true);
    setSnackbarMessage(row.roll_no + (row.registered ? ' Deregistered' : ' Registered'));
  };

  const handleSelectionChange = (selection) => {
    // Do something with selection if needed
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleAddRow = () => {
    const updatedStudents = qualifiedStudentsData.map(student =>
      ({ ...student, registered: true })
    );
    setQualifiedStudentsData(updatedStudents);
    setSnackbarOpen(true);
    setSnackbarMessage("All students Registered successfully");
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer sx={{ display: "flex", justifyContent: "end" }}>
        <div style={{ display: "flex", gap: 2 }}>
          <Button onClick={handleAddRow}>Register All</Button>
        </div>
      </GridToolbarContainer>
    );
  }

  const columns = [
    { field: "id", headerName: "ID", width: 50 },
    { field: "student_college_code", headerName: "Student College code", width: 150 },
    { field: "student_batch_id", headerName: "Student Batch ID", width: 120 },
    { field: "roll_no", headerName: "Roll no", width: 90 },
    { field: "student_name", headerName: "Student Name", width: 130 },
    { field: "student_image", headerName: "Student Image", width: 135 },
    { field: "branch_id", headerName: "Branch ID", width: 100 },
    { field: "mobile", headerName: "Mobile", width: 130 },
    { field: "email", headerName: "Email", width: 140 },
    {
      field: "action",
      headerName: "Action",
      renderCell: (params) => (
        userLevel === 1 && (
          <Button variant="contained" color={params.row.registered ? "error" : "success"} onClick={() => handleAction(params.row)}>
            {params.row.registered ? "Deregister" : "Register"}
          </Button>
        )
      ),
      width: 120,
    },
  ];

  return (
    <div style={{ textAlign: "center", width: "100%" }}>
      <Typography variant="h4">Eligible Students- {currentExam.currentExam} - {currentExam.currentExamName} </Typography>

      <div style={{ height: 400, width: "100%" }}>
        <DataGrid
          rows={qualifiedStudentsData}
          columns={columns}
          pageSize={5}
          checkboxSelection
          components={{ Toolbar: CustomToolbar }}
          onSelectionModelChange={handleSelectionChange}
        />
      </div>
      <Snackbar
      open={snackbarOpen}
      autoHideDuration={3000}
      onClose={handleCloseSnackbar}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} // Set anchor origin to bottom right
      >
    <MuiAlert
    onClose={handleCloseSnackbar}
    severity={snackbarMessage.includes('Registered') ? "success" : "error"}
    sx={{ width: '250px', backgroundColor: snackbarMessage.includes('Registered') ? '#4CAF50' : '#F44336', color: 'black' }}
    >
    {snackbarMessage}
  </MuiAlert>
</Snackbar>

    </div>
  );
};

export default QualifiedStudents;
